import { type ExternalFile } from '@/lib/types';
import useGetOneDriveFilePublicUrl from '../utils/microsoft/useGetOneDriveFilePublicUrl';
import * as Sentry from '@sentry/react';

const useMakeOneDriveExternalFilesPublic = () => {
  const getOneDriveFilePublicUrl = useGetOneDriveFilePublicUrl();

  const makeOneDriveExternalFilesPublic = async (
    externalFiles: ExternalFile[],
  ): Promise<ExternalFile[]> => {
    const publicExternalFiles = await Promise.all(
      externalFiles.map(
        async (externalFile: ExternalFile): Promise<ExternalFile> => {
          try {
            const publicUrl = await getOneDriveFilePublicUrl(
              externalFile.externalId,
            );

            return {
              ...externalFile,
              url: publicUrl,
            };
          } catch (error) {
            // no-op: we likely don't have sufficient permissions to get a public
            // URL. Still, we want to keep an eye on these errors for now.
            Sentry.captureException(error);

            return externalFile;
          }
        },
      ),
    );

    return publicExternalFiles;
  };

  return makeOneDriveExternalFilesPublic;
};

export default useMakeOneDriveExternalFilesPublic;
